import React, { Component } from 'react';

export default class CurrencyRateChange extends Component {
    render() {
        const { date } = this.props;

        const { USD_UZS } = this.props.data;
        let data = [];
        for (let x in USD_UZS) {
            data.push({ name: x, value: USD_UZS[x] })
        }
        return (
            <table className="table table-striped table-sm my-4">
                <thead className="thead-dark">
                    <tr>
                        <th>#</th>
                        <th>{date}</th>
                        <th>USD</th>
                        <th>UZS</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map((item, i) => {
                            return (
                                <tr key={item.name}>
                                    <td>{i + 1}</td>
                                    <td>{new Date(item.name).toLocaleDateString()}</td>
                                    <td>1 USD</td>
                                    <td>{item.value}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        );
    }
}
